// extracted by css-extract-rspack-plugin
export default {"ColorButton":"pF2hZ","large":"IT9aS","small":"Xot16","secondary":"VSvim","label":"YM4DK"};